<template>
  <div class="hello">
    <div class="bg">

      <div class="footer" @scroll="getS" ref="photo">
        <div class="footerNav" :style="{background:'url('+image+')',backgroundSize:'100% 100%'}" style="">
          <p>“ {{title}} ”</p>
          <span>{{retitle}}</span>
        </div>
        <div class="content">
          <div style="margin: 50px auto;width: 452px;height: 307px;"  v-if="contentList.length <= 0 && lang == 'cn'">
            <img src="../assets/image/zanwu.png" alt="">
          </div>
          <div style="margin: 50px auto;width: 452px;height: 307px;"  v-if="contentList.length <= 0 && lang == 'en'">
            <img src="../assets/image/zanwuE.png" alt="">
          </div>
          <div class="contentList" v-for="(item,index) in contentList" :key="index" @click="contentEvent(index,item.id,item.vote_status.key)">
            <div class="contentTop" :class="{contentType:item.cover_file_type == 'video'}">
              <video width="100%" height="100%" v-if="item.cover_file_type == 'video'" :src="item.cover_pic"  ></video>
              <img v-else :src="item.cover_pic" alt="">
            </div>
            <div class="contentBottom">
              <p>{{item.title}}</p>
              <span>票数：{{item.number}}</span>
              <div class="submitBtn" v-if="item.vote_status.key != 5" @click.stop="vote(item.id)">
                <span>{{$t('language.vote')}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="pages">
          <el-pagination background layout="prev, pager, next" v-if="show" :total="total" @current-change="change">
          </el-pagination>
        </div>
        <div class="end" @click="rankingEvent">
          <span>{{$t('language.Results')}}</span>
        </div>
        <div class="foottitle">
          <div class="footeT" :style="{background:'url('+ images +')',backgroundSize:'100%'}">
            <span>
              {{$t('language.Rules')}}
            </span>
          </div>
          <div class="content" v-html="textFu">

          </div>
        </div>
        <div class="footerHead">
           <div class="center_title">
              <div class="listB">地址:{{address}}</div>
              <div class="listB">电子邮箱:{{email}}</div>
           </div>
        </div>
      </div>
    </div>

    <div class="handDetail" v-if="rankingShow">
      <div class="end_content">
        <div class="close1" @click="closeEve">
          <img src="../assets/image/close.png" alt="">
        </div>
        <div class="end_top">
          <span>{{toupiaotitle}} </span>
        </div>
        <div class="end_title">
          <span>排行榜</span>
        </div>
        <div class="end_center">
          <el-table :data="tableData" :header-cell-style="{
    'color': 'rgb(0, 0, 0)',
}" style="width: 100%">
            <el-table-column prop="rank" label="排名" width="180">
            </el-table-column>
            <el-table-column prop="photographer_name" label="摄影师" width="180">
            </el-table-column>
            <el-table-column prop="title" label="展览名称">
            </el-table-column>
            <el-table-column prop="number" label="票数" width="100">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>



    <!-- 投票详情 -->
    <div class="handDetail" v-if="detailShow">
      <div class="swiper_list">
        <div class="swiper_lis" ref="swiperLis" >
          <div class="close" @click="closeEvent">
            <img src="../assets/image/closeone.png" alt="">
          </div>
         <video style="position: absolute;left: 0;right: 0;bottom: 0;top: 0;margin: auto; display: block;"  v-if="videoType"
            ref="videoPlay" :src="imageIr" controls="controls" @contextmenu="contextmenu"></video>
              <!-- <video width="100%" height="80%" v-if="videoType" :src="imageIr" controls="controls"></video> -->
          <img v-else  class="swiper_img" ref="swiperImg" :src="imageIr" alt="">
          <div class="prev" @click="prevEvent">
            <img src="../assets/image/swiper_left.png" alt="">
          </div>
          <div class="next" @click="nextEvent">
            <img src="../assets/image/swiper_right.png" alt="">
          </div>
            <div class="imageBtn" v-if="key != 5" @click.stop="vote(id)">
              <span>{{$t('language.vote')}}</span>
            </div>

          <div class="imagTitle" >
            <div class="headerImg">
             <img v-if="photographer_img != ''" :src="photographer_img"
                alt="">
                <img v-else src="../assets/image/defaultHeader.png" alt="">
            </div>
            <div class="headeright">
              <div class="head_title">
                {{titles}}
              </div>
              <div class="user">
                <span>摄影师 {{photographer_name}}</span>
              </div>
              <div class="nams">
                <!-- <span>院校：清华大学</span> -->
              </div>
            </div>
          </div>
        </div>
        <div class="swiper_footer">
          <!-- <div class="prev_mask">
            <img src="https://images.unsplash.com/photo-1592438893201-0e9e4d57d2cb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
              alt="">
          </div> -->
          <div class="center">
            <!-- <div class="listSwiper" :class="{swiperActive:item.isActive}" v-for="(item,index) in swiperTab" :key="index"
              @click="swiperEvent(index,item.display_path)">
              <img :src="item.display_path" alt="">
            </div> -->
             <swiper class="swiper" :options="swiperOptionO" ref="Swiper">
               <swiper-slide    v-for="(item,index) in swiperTab" :key="index" class="swiper-slides swiper-slide" >
                 <div :class="{swiperActive:item.isActive}"  style="width: 115px;height: 96px;"  @click="swiperEvent(index,item.display_path,item.file_type)">
                   <img v-if="item.file_type == 'image'" :src="item.display_path" style="width: 112px;height: 96px;" alt="">
                   <video v-else style="width: 100%;height: 100%;" :src="item.display_path"></video>
                   </div>
               </swiper-slide>
             </swiper>
          </div>
          <!-- <div class="next_mask">
            <img src="https://images.unsplash.com/photo-1593060671613-33b2d0984e9d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
              alt="">
          </div> -->
        </div>
      </div>
    </div>
    <fiex :shows="detailS" :fatherMethod="goT"></fiex>
  </div>
</template>

<script>
  import fiex from '../components/fiex.vue'
  export default {
    components:{
      fiex
    },
    data() {
      return {
        key:0,
        lang:'cn',
        rankingShow: false,
        swiperOptionO: {
          slidesPerView: 12,
          notNextTick: true,
          //设置点击箭头
          navigation: {
            nextEl: '.swiper_rightBtn',
            prevEl: '.swiper_leftBtn',
          },
          slidesPerView: 10.08,
          //自动轮播
          loop: false,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
        },
        photographer_name:'',
        photographer_img:'',
        titles:'',
        toupiaotitle:'',
        tableData: [],
        show:false,
         searchValue:'',
        handShow: false,
        detailS:false,
        detailShow: false,
        imageUrl: require('../assets/image/banner1.png'),
        image:'',
        images: require('../assets/image/bg.png'),
        index: 0,
        width: 61,
        imageIr: '',
        contentList: [],
        swiperTab: [],
        title: '',
        retitle: '',
        textFu: '',
        total: 10,
        pageNum: 1,
        playerOptions: {
          playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "",
            src: '' //url地址
          }],
          poster: "", //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, //当前时间和持续时间的分隔符
            durationDisplay: true, //显示持续时间
            remainingTimeDisplay: false, //是否显示剩余时间功能
            fullscreenToggle: true //全屏按钮
          }
        },
        address:'',
        email:'',
        id:null,
          keyshow:true,
          videoType:true
      }
    },
    created() {
       this.$fetch('/index/info').then(res=>{
           this.address = res.data.address;
           this.email = res.data.email;
       })
      if(localStorage.getItem('languageSet') == 'en'){
        this.lang = 'cn'
      }else{
        this.lang = 'en'
      }
      var that = this;
      if (this.$refs.swiperImg > 622) {
        this.width = 20;
      } else {
        this.width = 60;
      }

      var data = {
        id: this.$route.query.id
      }
      this.$fetch('/vote/actDetail', data).then(res => {
        this.image = res.data.bgimg_pc.display_path
        this.title = res.data.title;
        this.retitle = res.data.retitle;
        this.textFu = res.data.vote_explain
      })

      this.ajaxFun(this.pageNum)
    },

    methods: {

      contextmenu() {
        return false;
      },
      goT() {
        this.$refs.photo.scrollTop = 0;
      },
       // 触底出现悬浮
      getS(event){
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || this.$refs.photo.scrollTop ||
          window.pageYOffset;

          if(scrollTop > 20){
            this.detailS = true;
          }else{
            this.detailS = false;
          }
      },
      ajaxFun(page) {
        var datas = {
          id: this.$route.query.id,
          page: page
        }
        this.$fetch('/vote/itemList', datas).then(res => {
          this.contentList = res.data.data;
          this.total = res.data.total;
         if(this.tatol > 10){
           this.show = true;
         }else{
           this.show = false;
         }

        })
      },
      swiperEvent(index,path,type) {
      if (type == 'video') {
        this.videoType = true;
        this.$nextTick(() => {
          this.$refs.videoPlay.load()
        })
      } else {
        this.videoType = false;
      }
        this.index = index;
         console.log(this.swiperTab[index-1])
        for (var i = 0; i < this.swiperTab.length; i++) {
          this.swiperTab[i].isActive = false
        }
        this.swiperTab[index].isActive = true;
        this.imageIr =path
        console.log(this.$refs.swiperImg.clientHeight)

      },
      searchTap(){
        this.$router.push({
          path:'/search',
          query:{
            msg:this.searchValue
          }
        })
      },
      prevEvent() {
        if (this.index != 0) {
          this.index--;
        }

        for (var i = 0; i < this.swiperTab.length; i++) {
          this.swiperTab[i].isActive = false;
        }
        this.swiperTab[this.index].isActive = true;
        this.imageIr = this.swiperTab[this.index].display_path;

      },
      nextEvent() {
        if (this.index >= this.swiperTab.length - 1) {
          this.index = this.swiperTab.length - 1;
        } else {
          this.index++;
        }
        for (var i = 0; i < this.swiperTab.length; i++) {
          this.swiperTab[i].isActive = false
        }
        this.swiperTab[this.index].isActive = true;
        this.imageIr = this.swiperTab[this.index].display_path
        console.log(this.swiperTab[this.index])
      },
      mouseover() {
        this.handShow = true;
      },
      mouseout() {
        this.handShow = false;
      },
      closeEvent() {
        this.detailShow = false;
      },
      contentEvent(index, id,key) {
        this.detailShow = true;
        this.id = id;
        var data = {
          item_id: id
        }
        this.$fetch('/vote/itemDetail', data).then(res => {
          this.titles = res.data.title;
          this.photographer_name = res.data.photographer_name;
          this.photographer_img = res.data.photographer_img;
          res.data.vote_work.forEach(item=>{
            item.isActive = false;
          })

          console.log(this.imageIr);
            this.swiperTab = res.data.vote_work;
            this.swiperTab[0].isActive = true;
            this.imageIr = this.swiperTab[0].display_path;
            if(this.swiperTab[0].file_type == 'video'){
              this.videoType = true;
            }else{
              this.videoType = false;
            }
            this.key = key;

        })
      },
      rankingEvent() {
        var data = {
          id:this.$route.query.id
        }
        this.$fetch('/vote/rank',data).then(res=>{
            this.tableData = res.data.rank;
            this.toupiaotitle = res.data.vote_act_title
        })
        this.rankingShow = true;
      },
      closeEve() {
        this.rankingShow = false;
      },
      vote(id){
        console.log(id);
        if(!localStorage.getItem('refresh_token')){
            this.$message.error('请先登录')
        }
        var data = {
          id:this.$route.query.id,
          item_id:id
        }
        this.$post('/vote/itemVote',data).then(res=>{
                  console.log(res.data)
            if(res.code == 200){
              this.ajaxFun(this.pageNum);
              this.$message.success(res.message);
            }

            if(res.data.code == 401){
              this.$message.error(this.$t('language.onLogin'))
              this.$router.push('/')
            }
        })
      },
      change(e) {
        this.pageNum = e;
        this.ajaxFun(this.pageNum);
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/hand.css");
</style>



// WEBPACK FOOTER //
// src/pages/hand.vue